import { render, staticRenderFns } from "./Vacancies.vue?vue&type=template&id=0ab7cf36&scoped=true"
import script from "./Vacancies.vue?vue&type=script&lang=js"
export * from "./Vacancies.vue?vue&type=script&lang=js"
import style0 from "./Vacancies.vue?vue&type=style&index=0&id=0ab7cf36&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab7cf36",
  null
  
)

export default component.exports